export const OLIVEEB_COLORS = {
  green: "#0B9B06",
  greenDark: "#066902",
  greenSoft: "#E7F8E7",
  greenSoft2: "#F6FFF6",
  red: "#AE0505",
  redSoft: "#FDECEC",
  textPrimary: "#062701",
  textSecondary: "#6A7A6B",
  ink: "#111111",
  border: "#E6EFE7",
  bgSoft: "#F7FAF7",
  line: "#EEF2EE",
  chip: "#E8EEF1",
  white: "#FFFFFF",
  shadow: "rgba(0,0,0,0.08)",

  oliveebOrange: "#e65100",
  oliveebYellow: "#f8c10b",
  oliveebBrightYellow: "#FFFF00",

  bg: "#F6FBF9",
  card: "#FFFFFF",

  oliveebGreen: "#27ae30",
  oliveebGreenSoft: "#E7F6EF",
  oliveebDarkGreen: "#0e5604",

  oliveebBlue: "#2385DB",
  oliveebDarkBlue: "#090359",
  oliveebBlueSoft: "#EAF4FF",

  goldSoft: "#FFF8DB",
  goldBorder: "#F6E9A7",

  textMuted: "#475569",
  placeholder: "#94A3B8",

  oliveebRed: "#d90101",
  oliveebDarkRed: "#5b0d03",

  overlay: "rgba(15, 23, 42, 0.35)",
};